// @flow
import _ from 'lodash';
import { ThemeSetup } from '../themes/ThemeSetup';
import { FILE_EXTENSIONS } from '../../src/util/Constants';
let i = 0;
const unsupportedCharacters = /[*?|:"<>]/;

export function getUniqueKey() {
  return `${Date.now()}_${_.random(100000)}`;
}
function getExtensionType(fileName) {
  let arr = fileName.split('.');
  let ext = arr[arr.length - 1].toLowerCase();
  for (const property in FILE_EXTENSIONS) {
    FILE_EXTENSIONS[property].includes(ext);
    return property;
  }
}
function getPreview(type, file) {
  let preview = ThemeSetup.getImageURL('icon_file.svg');
  if (type === 'image') {
    preview = URL.createObjectURL(file);
  } else if (type === 'video') {
    preview = ThemeSetup.getImageURL('icon_video.svg');
  }
  return preview;
}
function inferPreview(file, isNameValid) {
  let preview = ThemeSetup.getImageURL('icon_file.svg');
  if (!isNameValid) {
    return preview;
  }

  if (file.type.indexOf('image') > -1) {
    preview = URL.createObjectURL(file);
  } else if (file.type.indexOf('video') > -1) {
    preview = ThemeSetup.getImageURL('icon_video.svg');
  } else if (file.type.indexOf('pdf') > -1) {
    preview = 'images/icon_pdf.svg';
  } else if (file.type == '') {
    let extType = getExtensionType(file.name);
    preview = getPreview(extType, file);
  }

  return preview;
}

export default class Upload {
  id: number;
  uniqueKey: any;
  file: File;
  path: ?string;
  collectionId: number;
  name: string;
  type: string;
  status: 'UPLOADING' | 'UPLOADED' | 'FINISHED' | 'ERROR' | 'CANCELED';
  imported: boolean;
  loaded: number;
  total: number;
  errorText: ?string;
  isNameValid: boolean;
  preview: string;

  constructor(file: File, path: ?string = undefined, collectionId: number = 0) {
    const isNameValid = !unsupportedCharacters.test(file.name);

    this.id = i++;
    this.uniqueKey = getUniqueKey();
    this.file = file;
    this.path = path;
    this.name = file.name;
    this.type = file.type;
    this.status = isNameValid ? 'UPLOADING' : 'ERROR';
    this.imported = isNameValid ? false : true;
    this.loaded = 0;
    this.total = 0;
    this.errorText = isNameValid ? null : 'Invalid characters in file name';
    this.isNameValid = isNameValid;
    this.preview = inferPreview(file, isNameValid);
    this.collectionId = collectionId;
  }

  get done(): boolean {
    return _.includes(['FINISHED', 'ERROR'], this.status);
  }
}
